/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';
import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import { hideOverlayDialog, showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../screens/screens.reducers';
import { hideInfoBanners } from '../../videoplayerui/infobanner/infobanner.reducers';
import { OverlayTypes } from '../OverlayTypes';

const GLOBAL_MOUSE_TRAP = 'HideSocuErrorOverlay';

export const onKeyBackSocuErrorOverlay = () => (dispatch: Function) => {
    dispatch(hideOverlayDialog());
};

export const onKeyOkSocuErrorOverlay = () => (dispatch: Function) => {
    dispatch(hideOverlayDialog());
};

export const onMouseClickSocuErrorOverlay = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;

    if (value === GLOBAL_MOUSE_TRAP) {
        dispatch(hideOverlayDialog());
        return;
    }

    dispatch(onKeyOkSocuErrorOverlay());
};

export const showSocuErrorOverlay = (error, hasDimmer: boolean = true) => (dispatch: Function) => {
    const overlayDialogProps: IOverlayDialog = {
        description: error?.getDescription(),
        hasDimmer,
        hasSeperator: false,
        messageCode: error?.getCode(),
        mouseTrapValue: GLOBAL_MOUSE_TRAP,
        options: [
            {
                text: Locale.getString(LocaleKeys.OVERLAY_OPTION_OK_TEXT),
                hasSelectMark: false,
                isSelected: true,
            },
        ],
        overlayType: OverlayTypes.NON_BLOCKING_ERROR,
        title: error.getTitle(),
    };
    dispatch(hideInfoBanners());
    dispatch(showOverlayDialog(overlayDialogProps));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.SOCU_ERROR_OVERLAY_TASKS));
};
